package br.com.vvrefeicoes.portal.domain.model

/**
 * Colunas da aba "Massa salarial", na ordem em que aparecem: uma linha por verba de cada
 * departamento do "Resumo da Folha" exportado pelo sistema de folha.
 */
enum class RhPayrollMassColumn(
    override val header: String,
    override val label: String,
    override val editable: Boolean = false,
) : RhSheetColumn {
    EMPRESA("empresa", "Empresa"),
    CNPJ("cnpj", "CNPJ"),
    DEPARTAMENTO("departamento", "Departamento"),
    UNIDADE("unidade", "Unidade"),
    CODIGO("codigo", "Código"),
    DESCRICAO("descricao", "Descrição"),
    ADICIONAIS("adicionais", "Adicionais", true),
    DESCONTOS("descontos", "Descontos", true),
    QTD_FUNCIONARIOS("qtd funcionarios", "Qtd. Funcionários", true),
    ;

    override val required: Boolean
        get() = this == CODIGO
}
